module.exports = __webpack_public_path__ + "static/media/Firefly_Logo_White_New.2fbe8d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Firefly_Logo_White_New.png
// module id = 90
// module chunks = 0